/**
 * Shared utility for checking missing task properties.
 * Used by both ExitPlanMode validation and post-PR backfill nudge.
 */

export function collectMissingProps(taskProps: {
  plan?: string | null;
  storyPointId?: string | null;
  title?: string | null;
  riskLevel?: string | null;
}): string[] {
  const missing: string[] = [];
  if (!taskProps.plan?.trim()) missing.push("plan (save via update_task_plan)");
  if (!taskProps.storyPointId) missing.push("story points (use update_task_properties)");
  if (!taskProps.title || taskProps.title === "Untitled")
    missing.push("title (use update_task_properties)");
  if (!taskProps.riskLevel)
    missing.push("risk (use update_task_properties — critical/high/medium/low)");
  return missing;
}
